import { useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@mui/material/Typography';
import { useEffect, useState } from 'react';
import { toCamelCase } from '../util/string';
import { Filter } from './catalogue/CatalogueFilter';
type SwitchBoxProps = {
  title: string;
  cleared: boolean;
  handleFilterChange: (title: string, filter: Filter) => void;
  filterFromQuery?: Filter;
  defaultChecked?: boolean;
};

export const DEFAULT_CHECKED_TITLES = [
  'Include Whitelist Items',
  'Include Rented Items',
];

export function SwitchBox({
  title,
  handleFilterChange,
  cleared,
  filterFromQuery,
  defaultChecked = false,
}: SwitchBoxProps) {
  const theme = useTheme();
  const [enabled, setEnabled] = useState<{ enabled: boolean }>({
    enabled: defaultChecked,
  });
  useEffect(() => {
    if (!filterFromQuery) {
      return;
    }
    setEnabled({ enabled: filterFromQuery.enabled });
  }, [filterFromQuery]);
  const handleToggle = () => {
    setEnabled((prev) => {
      return {
        enabled: !prev.enabled,
      };
    });
  };
  useEffect(() => {
    handleFilterChange(toCamelCase(title), {
      values: [],
      enabled: DEFAULT_CHECKED_TITLES.includes(title)
        ? !enabled.enabled
        : enabled.enabled,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enabled]);
  useEffect(() => {
    if (cleared) {
      setEnabled({ enabled: false });
    }
  }, [cleared]);
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        width: '100%',
        px: 4,
        py: 1,
        background: theme.palette.background.elevationSolid[4],
        borderRadius: '5px',
        boxShadow: theme.shadows[1],
      }}
    >
      <FormControl onChange={handleToggle} sx={{ width: '100%' }}>
        <FormControlLabel
          sx={{ ml: 0, justifyContent: 'space-between' }}
          labelPlacement="start"
          label={<Typography variant="body1">{title}</Typography>}
          control={<Switch checked={enabled.enabled} />}
        />
      </FormControl>
    </Box>
  );
}
